<template>
  <div>
    <br />
    <b-row class="row not-print" style="margin-left: 10px">
      <b-col>
        <form @keyup.enter="search()" @submit.prevent>
          <div class="row pt-3">
            <div class="col-4">
              <text-input
                v-model="searchForm.text"
                placeholder="Pesquisar"
                v-debounce:100ms="search"
              />
            </div>
            <div class="col-6">
              <button
                type="button"
                class="btn btn-sm btn-primary mr-3"
                @click="showFilters = !showFilters"
              >
                <i class="fas fa-filter" /> Mais Filtros
              </button>
              <button
                type="button"
                class="btn btn-sm btn-primary"
                @click="search()"
              >
                <i class="fas fa-search" /> Pesquisar
              </button>
            </div>

            <div class="col text-right mr-4">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                @click="print()"
              >
                <i class="fas fa-print mr-1" /> Imprimir
              </button>
            </div>
          </div>

          <b-collapse v-model="showFilters">
            <b-row>
              <b-col>
                <category-search
                  ref="CategorySearch"
                  @categorySelected="setCategory($event)"
                />
              </b-col>
              <b-col>
                <text-input v-model="searchForm.brand" alias="Marca" />
              </b-col>
              <b-col>
                <number-input
                  v-model="searchForm.max_value"
                  alias="Estoque Maior que"
                />
              </b-col>
              <b-col class="mr-4">
                <number-input
                  v-model="searchForm.min_value"
                  alias="Estoque Menor que:"
                />
              </b-col>
              <b-col>
                <text-input
                  type="date"
                  v-model="searchForm.date_start"
                  alias="Data de Vendas Inicial"
                />
              </b-col>
              <b-col class="mr-4">
                <text-input
                  type="date"
                  v-model="searchForm.date_end"
                  alias="Data de Vendas final"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="2" align-self="center">
                <b-button @click="clear()" class="x-small" size="sm">
                  <i class="fas fa-times" /> Limpar Filtro
                </b-button>
              </b-col>
              <b-col>
                <b-form-checkbox
                  switch
                  inline
                  @change="search()"
                  :value="1"
                  :unchecked-value="0"
                  v-model="searchForm.status"
                >
                  <small>Listar Somente Ativos</small>
                </b-form-checkbox>
              </b-col>
            </b-row>
            <br />
          </b-collapse>
        </form>
      </b-col>
    </b-row>
    <div class="row" style="margin: 3px">
      <div class="col">
        <b-card title="Relatório  de produtos">
          <br />
          <div class="mr-2 ml-1 row justify-content-between">
            {{ products.length }} registros encontrados!
            <span class="font-weight-bold"
              >Consulta Realizada : {{ date | dateTimeBr }}</span
            >
          </div>
        </b-card>
      </div>
    </div>
    <div class="row" style="margin: 3px">
      <div class="col">
        <div class="card">
          <b-table small :items="products" :fields="fields">
            <template #cell(price)="data">{{
              data.item.price | decimal
            }}</template>
            <template #cell(company_price_payment_immediate)="data">{{
              data.item.company_price_payment_immediate | decimal
            }}</template>
            <template #cell(company_price_payment_on_terms)="data">{{
              data.item.company_price_payment_on_terms | decimal
            }}</template>
            <template #cell(stock)="data">
              {{ data.item.stock | decimal }}
            </template>
            <template #cell(category)="data">{{
              getCategory(data.item.category)
            }}</template>
            <template #cell(brand)="data">{{
              getBrand(data.item.brand)
            }}</template>
            <template #cell(total_products_sold)="data">
              {{ data.item.total_products_sold | decimal }}
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import CategorySearch from "@/components/CategorySearch";

export default {
  props: {},
  components: {
    CategorySearch,
  },

  data() {
    return {
      fields: [
        {
          key: "base_sku_id",
          label: "Código",
          sortable: true,
          class: "text-center",
        },
        {
          key: "description",
          label: "Descrição",
          sortable: true,
          class: "text-center",
        },
        {
          key: "category",
          label: "Categoria",
          sortable: true,
          class: "text-center",
        },
        { key: "brand", label: "Marca", sortable: true, class: "text-center" },
        {
          key: "stock",
          label: "Estoque",
          sortable: true,
          class: "text-center",
        },
        {
          key: "total_products_sold",
          label: "Unidades Vendidas",
          sortable: true,
          class: "text-center",
        },
      ],

      products: [],
      showFilters: false,

      searchForm: {
        status: 1,
        text: null,
        brand: null,
        max_value: null,
        min_value: null,
        category_id: null,
        category_description: null,
        date_end: moment().format("YYYY-MM-DD"),
        date_start: moment().subtract(30, "days").format("YYYY-MM-DD"),
      },

      status_text: {
        1: "Somente ativos",
        0: "Somente inativos",
      },
    };
  },
  mounted() {
    this.$store.commit("pageHasLoaded");
    this.search();
    this.setColumnPrices();
  },
  computed: {
    date() {
      return moment().format();
    },

    enabledStock() {
      if (this.$store.state.company.module_stock_active == 1) {
        return true;
      }
    },

    enabledPolicePrice() {
      return this.$store.state.company.product_payment_policy == 2;
    },
  },

  methods: {
    setColumnPrices() {
      if (this.enabledPolicePrice) {
        this.$set(this.fields, 7, {
          key: "company_price_payment_immediate",
          label: "P.  Vista",
          sortable: true,
          class: "text-center",
        });
        this.$set(this.fields, 8, {
          key: "company_price_payment_on_terms",
          label: "P.  Prazo",
          sortable: true,
          class: "text-center",
        });
      } else {
        this.$set(this.fields, 7, {
          key: "price",
          label: "P. Venda ",
          sortable: true,
          class: "text-center",
        });
      }
    },
    getCategory(category) {
      if (category != null) {
        return category;
      }
      if (category == null) {
        return "Sem Categoria";
      }
    },

    getBrand(brand) {
      if (brand != null) {
        return brand;
      }
      if (brand == null) {
        return "Sem Marca";
      }
    },

    search() {
      this.$store
        .dispatch("products/getProductsReport", this.searchForm)
        .then((response) => {
          this.products = response.data;
        })
        .catch((error) => {
          this.error = error;
        });
    },

    setCategory(category) {
      this.searchForm.category_id = category.id;
      this.searchForm.category_description = category.description;
    },

    clear() {
      this.searchForm.status = 0;
      this.searchForm.text = null;
      this.searchForm.brand = null;
      this.searchForm.max_value = 0;
      this.searchForm.min_value = 0;

      (this.searchForm.date_end = moment().format("YYYY-MM-DD")),
        (this.searchForm.date_start = moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD")),
        this.$refs.CategorySearch.clear();
      this.searchForm.category_id = null;
    },
    print() {
      window.print();
    },
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  color: rgb(0, 0, 0);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 11pt;
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.page {
  width: 297mm;
  min-height: 210mm;
  padding: 0.5cm;
  margin: 0.5cm;
  border: 1px #d3d3d3 solid;
  /*    border-radius: 5px;*/
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.subpage {
  padding: 0cm;
  /*    border: 5px red solid;*/
  height: 256mm;
  outline: 2cm #ffeaea solid;
}

@page {
  size: A4;
  margin: 0.5cm;
  padding: 0.5cm;
}

@media print {
  .page {
    visibility: visible;
    margin: initial;
    border: rgba(0, 0, 0, 0.1);
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  .not-print {
    display: none;
  }
}
hr.color {
  border: 1px solid black;
}
</style>
